<template>
  <footer class="layout-footer mt-40">
    <div class="footer-container fc99 def-w pt-40" def-w>
      <a href="/web/" :title="site.name">
        <img :src="site.bottomLogo" :alt="site.name" />
      </a>
      <div class="flex mt-30">
        <div class="column" v-show="bottomNavList.length">
          <div class="title">网站导航</div>
          <div class="nav flex mt-30">
            <div
              class="nav-item"
              v-for="item in bottomNavList"
              :key="item.id"
              @click="handleNavClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="column">
          <div class="title">联系我们</div>
          <dl class="mt-30">
            <dd>{{ site.siteDescribe }}</dd>
            <dd>电话：{{ site.consultHotline }}</dd>
            <dd>邮箱：{{ site.email }}</dd>
            <dd>地址：{{ site.address }}</dd>
          </dl>
        </div>
        <div class="codes f-ac">
          <div class="code-item" v-for="(item, index) in codeList" :key="index">
            <template v-if="item.img">
              <img :src="item.img" alt="" />
              <div class="f-ac mt-10">
                <img src="@/assets/images/home/icon-weChat.png" alt="" />
                {{ item.title }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-info fc99">
      版权所有©中化商务有限公司 <img src="@/assets/images/home/beian.png" alt="" />京公网安备11010602202838号 京ICP备18039018号-6 增值电信业务经营许可证：京B2-20254023
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LayoutFooter",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["site", "bottomNavList"]),
    codeList() {
      return [
        {
          title: "中化商务公众号",
          img: this.site.zhswCode,
        },
        {
          title: "化云闲余公众号",
          img: this.site.hyxyCode,
        },
      ];
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleNavClick(res) {
      window.open(res.path);
    },
  },
};
</script>

<style scoped lang="scss">
.layout-footer {
  background-color: #333;

  .footer-container {
    padding: 40px 0 60px;

    .column {
      margin-right: 140px;

      .title {
        color: #ffffff;
      }

      .nav {
        width: 180px;
        flex-wrap: wrap;

        .nav-item {
          width: 56px;
          margin-right: 60px;
          margin-bottom: 20px;
          cursor: pointer;

          &:nth-of-type(2n) {
            margin-right: 0;
          }

          &:nth-of-type(n + 7) {
            margin-bottom: 0;
          }

          &:hover {
            color: #fff;
          }
        }
      }

      dl {
        dd {
          margin-bottom: 20px;
        }
      }
    }

    .codes {
      margin-left: auto;
      .code-item {
        margin-left: 20px;

        img {
          margin-right: 5px;
        }
      }
    }
  }

  .copyright-info {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: #ffffff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 15px;
      margin-left: 8px;
      margin-right: 2px;
    }
  }
}
</style>
